import React, { useState, useEffect } from "react";
import { useToasts } from "react-toast-notifications";
import Image from "components/Elements/Image/Image.tsx";
import { useUser } from "contexts/userContext/userContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import EmbedLimitOptionsModal from "components/Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";

const ButtonSettings = ({
  formButtonsColor,
  setFormButtonsColor,
  formButtonTextColor,
  setFormButtonTextColor,
  setUpdateBeforeSave,
}) => {
  const { addToast } = useToasts();
  const { isPremium } = useUser();
  const { setModal } = useModal();
  //Button:
  //ButtonBackgroundColor:
  const [updateButtonBackgroundColor, setUpdateButtonBackgroundColor] =
    useState(false);
  const [buttonBackgroundColorText, setButtonBackgroundColorText] =
    useState(formButtonsColor);
  const [focusBackgroundText, setFocusBackgroundText] = useState(null);
  const [blurBackgroundText, setBlurBackgroundText] = useState(null);
  const [focusBackgroundInput, setFocusBackgroundInput] = useState(null);
  const [blurBackgroundInput, setBlurBackgroundInput] = useState(null);
  useEffect(() => {
    if (blurBackgroundText !== focusBackgroundText) {
      validateColor(
        buttonBackgroundColorText,
        formButtonsColor,
        setFormButtonsColor,
        setUpdateButtonBackgroundColor
      );
    }
  }, [blurBackgroundText]);

  useEffect(() => {
    if (blurBackgroundInput !== focusBackgroundInput) {
      setUpdateButtonBackgroundColor(true);
    }
  }, [blurBackgroundInput]);
  useEffect(() => {
    if (updateButtonBackgroundColor) {
      setUpdateBeforeSave({ mode: true, action: "updateButtonColor" });
      setUpdateButtonBackgroundColor(false);
    }
  }, [updateButtonBackgroundColor]);
  //ButtonTextColor:
  const [focusButtonText, setFocusButtonText] = useState(null);
  const [blurButtonText, setBlurButtonText] = useState(null);
  const [focusButtonInput, setFocusButtonInput] = useState(null);
  const [blurButtonInput, setBlurButtonInput] = useState(null);
  const [updateButtonTextColor, setUpdateButtonTextColor] = useState(false);
  const [buttonTextColorText, setButtonTextColorText] =
    useState(formButtonTextColor);
  const { getTextByKey } = useContent();

  useEffect(() => {
    if (blurButtonText !== focusButtonText) {
      validateColor(
        buttonTextColorText,
        formButtonTextColor,
        setFormButtonTextColor,
        setUpdateButtonTextColor
      );
    }
  }, [blurButtonText]);

  useEffect(() => {
    if (blurButtonInput !== focusButtonInput) {
      setUpdateButtonTextColor(true);
    }
  }, [blurButtonInput]);

  const validateColor = (color, oldColor, setColor, setupdate) => {
    const validColorCode = new RegExp("^#(?:[0-9a-fA-F]{3}){1,2}$");
    if (validColorCode.test(color)) {
      setColor(color);
      setupdate(true);
    } else {
      addToast(getTextByKey("invalid-color-code"), {
        appearance: "error",
      });
      setColor(oldColor);
    }
  };

  const handleChangeButtonColorText = (e) => {
    if (isPremium()) {
      if (e.startsWith("#")) {
        setButtonBackgroundColorText(e);
      }
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };

  useEffect(() => {
    if (formButtonsColor) {
      setButtonBackgroundColorText(formButtonsColor);
    }
  }, [formButtonsColor]);

  //Color input:

  const handleChangeButtonColor = (e) => {
    if (isPremium()) {
      setFormButtonsColor(e);
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };

  ///////////////////Text Button:
  useEffect(() => {
    if (updateButtonTextColor) {
      setUpdateBeforeSave({ mode: true, action: "updateButtonTextColor" });
      setUpdateButtonTextColor(false);
    }
  }, [updateButtonTextColor]);
  //Text input:

  const handleChangeButtonTextColorText = (e) => {
    if (isPremium()) {
      if (e.startsWith("#")) {
        setButtonTextColorText(e);
      }
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };

  useEffect(() => {
    if (formButtonTextColor) {
      setButtonTextColorText(formButtonTextColor);
    }
  }, [formButtonTextColor]);

  //Color input:
  const handleChangeButtonTextColor = (e) => {
    if (isPremium()) {
      setFormButtonTextColor(e);
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };
  return (
    <div className="button-settings-container">
      <div className="title">{getTextByKey("button-settings-title")}</div>
      <div className="button-settings-content">
        <div className="button-form-color">
          <span>{getTextByKey("form-buttons-color")}</span>
          <div className="input-color-div">
            <div className="text-color">
              <input
                onFocus={(e) => setFocusBackgroundText(e.target.value)}
                onBlur={(e) => setBlurBackgroundText(e.target.value)}
                type="text"
                value={buttonBackgroundColorText}
                onChange={(e) => {
                  handleChangeButtonColorText(e.target.value);
                }}
              />
            </div>
            <div
              className="background-color"
              style={{ backgroundColor: formButtonsColor }}
            >
              <input
                onFocus={(e) => setFocusBackgroundInput(e.target.value)}
                onBlur={(e) => setBlurBackgroundInput(e.target.value)}
                value={formButtonsColor}
                onChange={(e) => handleChangeButtonColor(e.target.value)}
                type="color"
              />
            </div>
          </div>
        </div>
        <div className="button-form-color">
          <span>{getTextByKey("form-buttons-text-color")}</span>
          <div className="input-color-div">
            <div className="text-color">
              <input
                onFocus={(e) => setFocusButtonText(e.target.value)}
                onBlur={(e) => setBlurButtonText(e.target.value)}
                type="text"
                value={buttonTextColorText}
                onChange={(e) => {
                  handleChangeButtonTextColorText(e.target.value);
                }}
              />
            </div>
            <div
              className="background-color"
              style={{ backgroundColor: formButtonTextColor }}
            >
              <input
                onFocus={(e) => setFocusButtonInput(e.target.value)}
                onBlur={(e) => setBlurButtonInput(e.target.value)}
                value={formButtonTextColor}
                onChange={(e) => handleChangeButtonTextColor(e.target.value)}
                type="color"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="external-website-alert">
        <div className="exclamation-icon">
          <Image
            name="create-form/exclamation-icon"
            ext="svg"
            alt=""
            title=""
          />
        </div>
        <div className="alert-text">
          <span>{getTextByKey("design-relevent-external-website")}</span>
        </div>
      </div>
    </div>
  );
};

export default ButtonSettings;
